import React, { Component } from "react";
const $ = window.$;

var allSet = false;

export default class Comments extends Component {
    constructor(props) {
        super(props);
        this.interceptClick = this.interceptClick.bind(this);
        this.stressLevelChange = this.stressLevelChange.bind(this);
        this.cooperationChange = this.cooperationChange.bind(this);
        this.computerSkillChange = this.computerSkillChange.bind(this);
        this.state = {
            stressLevelValue: 0,
            cooperationValue: 0,
            computerSkillValue: 0
        };
    }

    componentDidMount() {
        this.afterUpdate();
    }

    componentDidUpdate() {
        this.afterUpdate();
    }

    afterUpdate() {
        this.props.setInterceptClick(this.interceptClick);

        if (!allSet && this.state.stressLevelValue > 0 && this.state.cooperationValue > 0 && this.state.computerSkillValue > 0) {
            allSet = true;
            this.props.clearDisableNext();
        }
    }

    stressLevelChange(value) {
        this.setState({ stressLevelValue: value });
    }

    cooperationChange(value) {
        this.setState({ cooperationValue: value });
    }

    computerSkillChange(value) {
        this.setState({ computerSkillValue: value });
    }

    interceptClick(type) {
        if (type === "next") {
            const response = {
                stressLevel: this.state.stressLevelValue,
                cooperation: this.state.cooperationValue,
                computerSkill: this.state.computerSkillValue,
                notes2: $("#notes2").val()
            };

            this.props.next(response);
            return true;
        }

        return false;
    }

    render() {
        return (
<div className="test-page-content-inner test-page-comments">
    <h1>Post-Test Comments</h1>
    <div className="comments-options-columns">
        <div className="remark-labels">
            <div>High</div>
            <div>Medium</div>
            <div>Low</div>
        </div>
        <div className="comments-options-column">
            <div>Stress Level</div>
            {renderOptions("stressLevel", this.stressLevelChange)}
        </div>
        <div className="comments-options-column">
            <div>Cooperation</div>
            {renderOptions("cooperation", this.cooperationChange)}
        </div>
        <div className="comments-options-column">
            <div>Computer Skill</div>
            {renderOptions("computerSkill", this.computerSkillChange)}
        </div>
    </div>
    <hr/>
    <div className="comments-notes">
        <div className="comments-notes-label">Notes:</div>
        <textarea id="notes2" cols="80" rows="6" maxLength="640"></textarea>
    </div>
</div>
        );
    }
}

function renderOptions(dataField, optionChange) {
    const arr = [];

    for (let i = 1; i <= 5; i++) {
        arr.push(renderOption(dataField, i, optionChange));
    }

    return arr;
}

function renderOption(dataField, optionValue, optionChange) {
    const id = `${dataField}-${optionValue}`;

    return (
<div className="inputGroup" key={id}>
    <input id={id} type="radio" name={dataField} value={optionValue} onChange={() => optionChange(optionValue)} />
    <label htmlFor={id}><span><span /></span></label>
    <span className="option-text">{optionValue}</span>
</div>
    );
}
